module.exports = __webpack_public_path__ + "processes.pdf";